<template>
    <!-- 对话框 -->
    <el-dialog title="添加奖品" :visible.sync="show" :before-close="closeDialog" style="width:1000px; margin: 0 auto;">

        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form label-width="80px">

                <el-form-item label="奖项名称 :" label-width='130px'>
                    <el-input v-model="submit_data.prize_name" style="width: 160px;">
                    </el-input>
                </el-form-item>


                <el-form-item label="奖项描述 :" label-width='130px'>
                    <el-input v-model="submit_data.prize_content" placeholder="请输入描述" style="width: 160px;">
                    </el-input>
                </el-form-item>

                <el-form-item label="奖品数量 :" label-width='130px'>
                    <el-input v-model="submit_data.prize_num" style="width: 160px;">
                    </el-input>
                </el-form-item>

                <el-form-item label="中奖率 :" label-width='130px'>
                    <el-input v-model="submit_data.prob" style="width: 160px;">
                    </el-input>%
                </el-form-item>

                <el-form-item label="奖品位置 :" label-width='130px'>
                    <el-input v-model="submit_data.level" placeholder="请输入1-8数字"  style="width: 160px;">
                    </el-input>
                </el-form-item>

                <el-form-item label="奖项类型:" label-width='130px'>
                    <el-select v-model="submit_data.type" placeholder="请选择">
                        <el-option
                                label="余额"
                                value="1">
                        </el-option>
                        <el-option
                                label="优惠券"
                                value="2">
                        </el-option>
                        <el-option
                                label="谢谢惠顾"
                                value="0">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额 :" label-width='130px' v-if="submit_data.type == 1">
                    <el-input v-model="submit_data.amount" placeholder="请输入金额"  style="width: 160px;">
                    </el-input>
                </el-form-item>

                <el-form-item label="优惠券:" label-width='130px' v-if="submit_data.type == 2">
                    <el-select
                            v-model="value_coupon_code"
                            placeholder="请选择优惠券"
                            @visible-change="couponList"
                            @change="couponChange"
                            clearable

                            style="position: relative"
                    >
                        <el-option
                                v-for="item in options_coupon_code"
                                :key="item.value"
                                :label="item.name"
                                :value="item.coupon_mode_code"
                        >
                        </el-option>





                        <el-pagination class="pagination" layout="prev, pager, next" :total="selectPages_coupon_data.count"
                                       :page-size="coupon_options_data.limit" @current-change="selectPages_coupon_function"
                                       :current-page="coupon_options_data.page"/>

                    </el-select>
                </el-form-item>



            </el-form>

            <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
                <el-button type="primary" @click="editPrize">保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.submit_data.prize_code = _this.data;

                _this
                    .$post('/prize/getPrizeDetails', {
                        prize_code:_this.data
                    })
                    .then((res) => {

                        _this.submit_data.prize_name = res.data.prize_name;
                        _this.submit_data.prize_content = res.data.prize_content;
                        _this.submit_data.prize_num = res.data.prize_num;
                        _this.submit_data.prob = res.data.prob;
                        _this.submit_data.coupon_mode_code = res.data.coupon_mode_code;
                        _this.submit_data.level = res.data.level;
                        _this.submit_data.type = res.data.type.val;

                        _this.value_coupon_code = res.data.coupon_name


                    })
                    .catch((err) => {
                    });

            },

        },
        data() {
            return {

                show: false,

                value_coupon_code:'',
                coupon_options_data: {
                    page: 1,
                    limit: 5
                },
                options_coupon_code:[],
                selectPages_coupon_data:[],


                // 表单提交数据
                submit_data: {
                    prize_code:'',
                    prize_name: '',
                    prize_content: '',
                    prize_num:'',
                    prob:'',
                    level:'',
                    type:'',
                    amount:'',
                    coupon_mode_code:'',
                },



            };
        },
        created() {
            _this = this;

        },
        methods: {
            selectPages_coupon_function(search_data) {
                _this.coupon_options_data.page = search_data;

                _this.couponList();
            },
            couponList(){
                _this
                    .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                    .then((res) => {
                        _this.selectPages_coupon_data = res;
                        _this.options_coupon_code = res.data;
                    })
                    .catch((err) => {
                    });
            },

            couponChange(val) {
                _this.submit_data.coupon_mode_code = val;
            },
            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.submit_data = {
                    prize_code:'',
                    prize_name: '',
                    prize_content: '',
                    prize_num:'',
                    prob:'',
                    level:'',
                    type:'',
                    amount:'',
                    coupon_mode_code:'',
                }

                _this.value_coupon_code = ''
            },

            // 提交按钮
            editPrize() {

                _this.$post(
                    '/prize/editNoticeSubmit',
                    _this.submit_data
                )
                    .then(res => {


                        _this.$message.success(res.msg);

                        _this.closeDialog();

                        _this.$emit('onSubmit');


                    }).catch((err) => {

                })

            },

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
</style>
